import React, { MouseEvent, useRef, useState } from 'react';
import { Placement } from '@popperjs/core';
import classNames from 'classnames';
import { EventBus } from 'src/common/EventBus';
import { TooltipComponent } from 'src/common/tooltip/component';
import { IconButton } from 'src/common/icon-button';
import { CopyStrongIcon, DeleteStrongIcon, DotMenuStrongIcon, MailStrongIcon } from 'src/monet/icons';
import { DashboardSettingsMembersOptions } from './options';

interface Props {
  userId: string;
  isUserInvited: boolean;
}

export const DashboardSettingsMembersActions = ({ userId, isUserInvited }: Props) => {
  const [keepMenuOpen, setKeepMenuOpen] = useState(false);
  const menuPlacementRef = useRef<Placement>();

  const onMenuOpen = (placement?: Placement) => {
    menuPlacementRef.current = placement;
    setKeepMenuOpen(true);
  };

  const onMenuClose = () => {
    setKeepMenuOpen(false);
  };

  const stopPropagation = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  const onRevokeUserConfirmed = () => {
    EventBus.emit('dashboard-settings:revoke-user', userId);
  };

  const onRemoveInviteClicked = () => {
    EventBus.emit('dashboard-settings:remove-invitation', userId);
  };

  const onCopyInviteUrlClicked = () => {
    EventBus.emit('dashboard-settings:copy-invitation-url', userId);
  };

  const onResendInviteClicked = () => {
    EventBus.emit('dashboard-settings:resend-invitation', userId);
  };

  return (
    <div
      className={classNames(
        'flex transition group-hover:opacity-100 grow-0 items-center space-x-sm',
        keepMenuOpen ? 'opacity-100' : 'opacity-0'
      )}
      onClick={stopPropagation}
    >
      {isUserInvited ? (
        <div className='flex items-center space-x-sm'>
          <TooltipComponent placement='top' tooltipContent='Resend invitation'>
            <IconButton onClick={onResendInviteClicked}>
              <MailStrongIcon />
            </IconButton>
          </TooltipComponent>
          <TooltipComponent placement='top' tooltipContent='Copy invite URL'>
            <IconButton onClick={onCopyInviteUrlClicked}>
              <CopyStrongIcon />
            </IconButton>
          </TooltipComponent>
          <TooltipComponent placement='top' tooltipContent='Delete invitation'>
            <IconButton onClick={onRemoveInviteClicked}>
              <DeleteStrongIcon />
            </IconButton>
          </TooltipComponent>
        </div>
      ) : (
        <DashboardSettingsMembersOptions
          renderMenuOrigin={(onClick) => (
            <IconButton onClick={onClick}>
              <DotMenuStrongIcon />
            </IconButton>
          )}
          userId={userId}
          nestedMenuPlacement={menuPlacementRef.current}
          onMenuOpen={onMenuOpen}
          onMenuClose={onMenuClose}
          onRevokeUserConfirm={onRevokeUserConfirmed}
        />
      )}
    </div>
  );
};
